import {
  aplicarMascaraEValidarData,
  dateBrToInt,
  isDataValida,
  aplicarMascaraDeData
} from '@/shared/utils/date-validator'
import { removeValoresVazios } from '@/shared/utils/clean-empty-objects'
import { extrairMensagemErroApi, isErroPedidoMedico } from '@/shared/utils/api-error.helper'
import DicomPlusMixin from '@/shared/mixins/dicom-plus.mixin'
import { aplicarMascaraCpf, validarCpf } from '@/shared/utils/cpf-validator'
import { aplicarMascaraTelefone } from '@/shared/utils/telephone-validator'
import AnexarArquivosModal from './components/dicom-plus-modal-attach-file/index.vue'
import CONSTANTS from '@/shared/constants/constants'
import { showDialog } from '../../../shared/sweetAlerts/showDialog'
import Swal from 'sweetalert2';
import DicomPlusModalFooter from './dicom-plus-modal-footer.vue'
import html2pdf from 'html2pdf.js'
import { formatDateBR } from '../../../shared/utils/date-validator'
import DicomPlusModalTabEstudo from './components/dicom-plus-modal-tab-estudo/index.vue'
import DicomPlusModalTabPaciente from './components/dicom-plus-modal-tab-paciente/index.vue'
import DicomPlusModalTabComplementares from './components/dicom-plus-modal-tab-complementares/index.vue'
import DicomPlusModalTabMamografia from './components/dicom-plus-modal-tab-mamografia/index.vue'
import DicomPlusModalDuplicarExame from './components/dicom-plus-modal-duplicar-exame/index.vue'

export default {
  name: 'dicom-plus-modal',
  props: ['exam'],
  mixins: [DicomPlusMixin],
  components: {
    AnexarArquivosModal,
    DicomPlusModalFooter,
    DicomPlusModalTabEstudo,
    DicomPlusModalTabPaciente,
    DicomPlusModalTabComplementares,
    DicomPlusModalTabMamografia,
    DicomPlusModalDuplicarExame
  },
  provide() {
    return {
      dicomPlusModal: this
    }
  },

  data() {
    return {
      isCommentOverflow: false,
      MAX_COMMENT_BYTES: 32768,
      currentCharCount: 0,
      exceededChars: 0,
      allFilesSoc: false,
      isExameDuplicate: false,
      mostrarSoc: false,
      campoSocAtivo: null,
      socItems: [],
      socTotal: 0,
      socPageCount: 1,
      socPage: 1,
      socPageSize: 10,
      objetoPaciente: null,
      mostrarGSaude: false,
      gsaudeappText: '',
      requisicaoID: '',
      isExamNotExistGestorSaude: false,
      procedimentoID: '',
      selectedFichaId: null,
      activeTab: 'estudo',
      showConfirmarSair: false,
      showDuplicarExame: false,
      dirtyBit: null,
      paciente: {
        nome: '',
        dataNascimento: '',
        sexo: '',
        socialName: '',
        patientID: '',
        studyInstanceUID: ''
      },
      estudo: {
        unidade: '',
        especialidade: '',
        subEspecialidade: '',
        contraste: '',
        contrasteVia: '',
        contrasteTipo: '',
        tipoAvaliacaoOncologia: '',
        diagnosticoHipotese: '',
        trauma: '',
        avc: '',
        leito: '',
        oncologico: '',
        comentarios: '',
        prioridade: null,
        especialidadeDuplicar: '',
        subEspecialidadeDuplicar: '',
        modality: '',
        studyDescription: '',
        studyDate: '',
        studyTime: '',
        medicoID: '',
        nomeMedico: ''
      },
      mamografia: {
        // Dados pessoais
        telefone: '',
        // Menstruação e gravidez
        dataUltimaMenstruacao: '',
        isGravida: '',
        vezesGravida: '',
        // Hormônios menopausa
        isHormonioMenopausa: '',
        // Plástica mamária
        isPlasticaMamas: '',
        realizouPlasticaMamas: '',
        // Biópsia/punção
        isBiopsiaOuPuncao: '',
        tempoBiopsiaOuPuncao: '',
        resultadoBiopsiaOuPuncao: '',
        // Parente com câncer de mama
        isParenteCancerMama: '',
        quemParenteCancerMama: '',
        // Exames anteriores
        isMamografiaAnterior: '',
        isMamografiaComparacao: '',
        isUltrassonografiaAnterior: '',
        isUltrassonografiaComparacao: '',
        // Cirurgias
        naoFezCirurgia: false,
        cirurgiaBiopsiaLindonodo: false,
        cirurgiaBiopsiaExacional: false,
        cirurgiaBiopsiaIncisional: false,
        cirurgiaCentralectomia: false,
        cirurgiaPlastica: false,
        cirurgiaDutectomia: false,
        cirurgiaInclusaoImplantes: false,
        cirurgiaLinfadenectomiaAxilar: false,
        cirurgiaMastectomia: false,
        cirurgiaMatectomiaComplexoAreolo: false,
        cirurgiaMastectomiaPoupadora: false,
        cirurgiaMastoplastiaRedutora: false,
        cirurgiaReconstrucaoMamaria: false,
        cirurgiaSegmentectomia: false,
        // Queixas
        queixaDor: false,
        queixaDorDireito: false,
        queixaDorEsquerdo: false,
        queixaDorTempo: '',

        queixaNodulo: false,
        queixaNoduloDireito: false,
        queixaNoduloEsquerdo: false,
        queixaNoduloTempo: '',

        queixaSecrecaoMamilar: false,
        queixaSecrecaoMamilarDireito: false,
        queixaSecrecaoMamilarEsquerdo: false,
        queixaSecrecaoMamilarTempo: '',

        queixaAlteracaoMamilo: false,
        queixaAlteracaoMamiloDireito: false,
        queixaAlteracaoMamiloEsquerdo: false,
        queixaAlteracaoMamiloTempo: '',

        queixaAlteracaoPele: false,
        queixaAlteracaoPeleDireito: false,
        queixaAlteracaoPeleEsquerdo: false,
        queixaAlteracaoPeleTempo: '',

        queixaRotinaPrevencao: false,
        queixaRotinaPrevencaoDireito: false,
        queixaRotinaPrevencaoEsquerdo: false,
        queixaRotinaPrevencaoTempo: ''
      },
      camposComplementares: [],
      formComplementares: {},
      especialidadeOptions: [],
      especialidadeDuplicarOptions: [],
      viaAdministracaoOptions: [],
      tipoContrasteOptions: [],
      tipoAvaliacaoOncologia: [],
      diagnosticoHipotese: [],
      medicoUSOptions: [],
      prioridadeOptions: [],
      showAnexarArquivos: false,
      anexoTipoOptions: [],
      tipoAnexo: null,
      savedFiles: [],
      anexos: [],
      attachedFilesCount: 0,
      duplicacoes: [{ specialityID: '', subSpeciality: '', requisicaoID: '', procedimento: '', deleted: false }],

      // Modal dinâmico de confirmação
      showModalConfirmar: false,
      modalConfirmarMensagem: '',
      modalConfirmarAcao: null,

      // AUTOCOMPLETE ESPECIALIDADE
      especialidadeSearch: '',
      dropdownEspecialidadeAberto: false,
      especialidadeFiltrada: [],
      // Dados Complementares - validação de campos
      cpfValido: true,
      dataNascimentoValida: true,
      setPhysician: false,
      physicianRequired: false,
    }
  },
  watch: {
    exam: {
      immediate: true,
      handler(newExam) {
        this.paciente = {
          nome: newExam?.nome || newExam?.paciente || newExam?.PatientName || '',
          dataNascimento: newExam?.dataNascimento || newExam?.patientBirthDate || newExam?.PatientBirthDate || '',
          sexo: newExam?.sexo || newExam?.patientSex || newExam?.PatientSex || '',
          socialName: newExam?.socialName || '',
          patientID: newExam?.patientID || newExam?.PatientID || '',
          studyInstanceUID: newExam?.studyInstanceUID || newExam?.StudyInstanceUID || ''
        }
        this.carregarEspecialidades()
        this.buscarPrioridades()
      }
    },
    'estudo.especialidadeOptions': {
      handler(nv) {
        this.especialidadeFiltrada = nv || []
      },
      immediate: true
    },
    'estudo.especialidade': {
      handler(nv) {
        const list = this.estudo.especialidadeOptions
        if (Array.isArray(list) && list.length) {
          const sel = list.find((e) => String(e.value) === String(nv))
          if (sel) this.especialidadeSearch = sel.label
        }
         if (this.showPhysicianField) {
          this.estudo.medicoID = '';
          this.buscarMedicosPorEspecialidade();
        }
      }
    },
    'mamografia.naoFezCirurgia'(novoValor) {
      if (novoValor) {
        this.mamografia.cirurgiaBiopsiaLindonodo = false
        this.mamografia.cirurgiaBiopsiaExacional = false
        this.mamografia.cirurgiaBiopsiaIncisional = false
        this.mamografia.cirurgiaCentralectomia = false
        this.mamografia.cirurgiaPlastica = false
        this.mamografia.cirurgiaDutectomia = false
        this.mamografia.cirurgiaInclusaoImplantes = false
        this.mamografia.cirurgiaLinfadenectomiaAxilar = false
        this.mamografia.cirurgiaMastectomia = false
        this.mamografia.cirurgiaMatectomiaComplexoAreolo = false
        this.mamografia.cirurgiaMastectomiaPoupadora = false
        this.mamografia.cirurgiaMastoplastiaRedutora = false
        this.mamografia.cirurgiaReconstrucaoMamaria = false
      }
    },
    // DOR
    'mamografia.queixaDorDireito'(val) {
      if (val) {
        this.mamografia.queixaDor = true
      } else if (!this.mamografia.queixaDorDireito && !this.mamografia.queixaDorEsquerdo) {
        this.mamografia.queixaDor = false
      }
    },
    'mamografia.queixaDorEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaDor = true
      } else if (!this.mamografia.queixaDorDireito && !this.mamografia.queixaDorEsquerdo) {
        this.mamografia.queixaDor = false
      }
    },
    // NÓDULO
    'mamografia.queixaNoduloDireito'(val) {
      if (val) {
        this.mamografia.queixaNodulo = true
      } else if (!this.mamografia.queixaNoduloDireito && !this.mamografia.queixaNoduloEsquerdo) {
        this.mamografia.queixaNodulo = false
      }
    },
    'mamografia.queixaNoduloEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaNodulo = true
      } else if (!this.mamografia.queixaNoduloDireito && !this.mamografia.queixaNoduloEsquerdo) {
        this.mamografia.queixaNodulo = false
      }
    },
    // SECREÇÃO MAMILAR
    'mamografia.queixaSecrecaoMamilarDireito'(val) {
      if (val) {
        this.mamografia.queixaSecrecaoMamilar = true
      } else if (!this.mamografia.queixaSecrecaoMamilarDireito && !this.mamografia.queixaSecrecaoMamilarEsquerdo) {
        this.mamografia.queixaSecrecaoMamilar = false
      }
    },
    'mamografia.queixaSecrecaoMamilarEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaSecrecaoMamilar = true
      } else if (!this.mamografia.queixaSecrecaoMamilarDireito && !this.mamografia.queixaSecrecaoMamilarEsquerdo) {
        this.mamografia.queixaSecrecaoMamilar = false
      }
    },
    // ALTERACAO DO MAMILO
    'mamografia.queixaAlteracaoMamiloDireito'(val) {
      if (val) {
        this.mamografia.queixaAlteracaoMamilo = true
      } else if (!this.mamografia.queixaAlteracaoMamiloDireito && !this.mamografia.queixaAlteracaoMamiloEsquerdo) {
        this.mamografia.queixaAlteracaoMamilo = false
      }
    },
    'mamografia.queixaAlteracaoMamiloEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaAlteracaoMamilo = true
      } else if (!this.mamografia.queixaAlteracaoMamiloDireito && !this.mamografia.queixaAlteracaoMamiloEsquerdo) {
        this.mamografia.queixaAlteracaoMamilo = false
      }
    },
    // ALTERACAO DA PELE
    'mamografia.queixaAlteracaoPeleDireito'(val) {
      if (val) {
        this.mamografia.queixaAlteracaoPele = true
      } else if (!this.mamografia.queixaAlteracaoPeleDireito && !this.mamografia.queixaAlteracaoPeleEsquerdo) {
        this.mamografia.queixaAlteracaoPele = false
      }
    },
    'mamografia.queixaAlteracaoPeleEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaAlteracaoPele = true
      } else if (!this.mamografia.queixaAlteracaoPeleDireito && !this.mamografia.queixaAlteracaoPeleEsquerdo) {
        this.mamografia.queixaAlteracaoPele = false
      }
    },
    // ROTINA PREVENÇÃO
    'mamografia.queixaRotinaPrevencaoDireito'(val) {
      if (val) {
        this.mamografia.queixaRotinaPrevencao = true
      } else if (!this.mamografia.queixaRotinaPrevencaoDireito && !this.mamografia.queixaRotinaPrevencaoEsquerdo) {
        this.mamografia.queixaRotinaPrevencao = false
      }
    },
    'mamografia.queixaRotinaPrevencaoEsquerdo'(val) {
      if (val) {
        this.mamografia.queixaRotinaPrevencao = true
      } else if (!this.mamografia.queixaRotinaPrevencaoDireito && !this.mamografia.queixaRotinaPrevencaoEsquerdo) {
        this.mamografia.queixaRotinaPrevencao = false
      }
    },
    'procedimentoID'(newVal) {
      const sanitized = String(newVal || '').replace(/\D/g, '');
      if (sanitized !== String(newVal || '')) {
        this.procedimentoID = sanitized;
      }
    },
    'isExamNotExistGestorSaude'(newVal, oldVal) {
      if (newVal === true) {
        this.procedimentoID = '';
      } else if (oldVal === true && newVal === false) {
        this.procedimentoID = String(this.procedimentoID || '').replace(/\D/g, '');
        this.$nextTick(() => {
          const el = document.getElementById('gsaudeappText');
          if (el) {
            try {
              el.focus();
              el.dispatchEvent(new Event('input', { bubbles: true }));
            } catch (e) {
              console.warn('falha ao disparar input event', e);
            }
          }
        });
      }
    },
    'estudo.comentarios': {
      handler(newValue) {
        if (!newValue) {
          this.isCommentOverflow = false
          this.currentCharCount = 0
          this.exceededChars = 0
          return
        }

        const sanitized = newValue.replace(/<\/?[^>]+(>|$)/g, '')
        const byteLength = new TextEncoder().encode(sanitized).length

        this.currentCharCount = byteLength
        this.isCommentOverflow = byteLength > this.MAX_COMMENT_BYTES
        this.exceededChars = this.isCommentOverflow ? byteLength - this.MAX_COMMENT_BYTES : 0
      },
      immediate: true
    }
  },
  methods: {
    async confirmarSalvarExame() {
      this.validarEspecialidadeInput();
      const { nome, dataNascimento, sexo } = this.paciente
      const obrigatorios = [
        { nome: 'Especialidade', valor: this.estudo?.especialidade },
        { nome: 'Nome do paciente', valor: nome?.trim() },
        { nome: 'Data de nascimento', valor: dataNascimento },
        { nome: 'Sexo', valor: sexo?.trim() }
      ]

      const faltandoPrincipais = obrigatorios.filter((campo) => !campo.valor)

      if (faltandoPrincipais.length) {
        const nomes = faltandoPrincipais.map((campo) => campo.nome).join(', ')
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.required_fields'),
          text: `${nomes}`,
          confirmButtonText: 'OK'
        })
        return
      }
      const faltando = this.validarCamposComplementaresObrigatorios()
      if (faltando.length) {
        const nomes = faltando.map((campo) => campo.titulo).join(', ')
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.required_fields'),
          text: `${nomes}`,
          confirmButtonText: 'OK'
        })
        return
      }
      if (!isDataValida(dataNascimento)) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.invalid_data'),
          text: this.$t('dicom_plus.dialog_message.invalid_date_of_birth'),
          confirmButtonText: 'OK'
        })
        return
      }
      const campoCpf = this.camposComplementares.find((campo) => campo.special === 1);
      if (campoCpf) {
        const valorCpf = this.formComplementares[campoCpf.titulo];
        if (valorCpf && valorCpf.trim() !== '' && !this.cpfValido) {
          showDialog({
            icon: 'warning',
            title: this.$t('dicom_plus.dialog_message.invalid_data'),
            text: this.$t('dicom_plus.dialog_message.invalid_cpf'),
            confirmButtonText: 'OK'
          })
          return;
        }
      }

      await showDialog({
        title: this.$t('dicom_plus.dialog_message.confirmation'),
        text: this.$t('dicom_plus.dialog_message.confirm_save'),
        confirmButtonText: this.$t('dicom_plus.yes'),
        denyButtonText: this.$t('dicom_plus.no'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: this.salvarDados
      })
    },
    fecharDuplicarExame() {
      this.showDuplicarExame = false;
    },
    async confirmarSalvarDuplicacao() {
      const duplicacaoInvalida = this.duplicacoes.some(
        d => !d.deleted && (!d.specialityID || String(d.specialityID).trim() === '')
      );
      if (duplicacaoInvalida) {
        await showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.warn'),
          text: this.$t('dicom_plus.dialog_message.add_speciality'),
          confirmButtonText: 'OK'
        });
        return;
      }

      try {
        this.$root.$emit('showLoading');

        const especialidadePrincipal = this.estudo?.especialidade;
        const statusExame = this.exam?.status;

        const especialidadesDuplicadas = this.duplicacoes
          .filter(d => d.specialityID && !d.deleted)
          .map(d => String(d.specialityID));

        if (
          statusExame === CONSTANTS.DICOM_PLUS_STATUS.PENDENTE &&
          especialidadePrincipal &&
          especialidadesDuplicadas.includes(String(especialidadePrincipal))
        ) {
          const especialidadeLabel =
            (this.estudo.especialidadeDuplicarOptions || [])
              .find(opt => String(opt.value) === String(especialidadePrincipal))?.label
            || String(especialidadePrincipal);

          this.$root.$emit('hideLoading');

          await showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.speciality_already_informed'),
            text: this.$t('dicom_plus.dialog_message.exam_already_exists_with_the_specialty',
              { speciality: especialidadeLabel }),
            confirmButtonText: 'OK'
          });
          return;
        }

        const set = new Set();
        const duplicadasNaTela = especialidadesDuplicadas.filter(e => {
          if (set.has(e)) return true;
          set.add(e);
          return false;
        });
        if (duplicadasNaTela.length) {
          this.$root.$emit('hideLoading');

          const labels = duplicadasNaTela
            .map(value => {
              const opt = (this.estudo.especialidadeDuplicarOptions || [])
                .find(o => String(o.value) === String(value));
              return opt ? opt.label : value;
            });

          let msg = labels.join(', ');
          if (labels.length > 1) {
            msg = [
              ...labels.slice(0, -1),
              'e ' + labels[labels.length - 1]
            ].join(', ');
          }

          await showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.speciality_already_informed'),
            text: this.$t('dicom_plus.dialog_message.exam_already_exists_with_the_specialty',
              { speciality: msg }),
            confirmButtonText: 'OK'
          });

          return;
        }

        for (const duplicacao of this.duplicacoes.filter(d => d.specialityID && !d.deleted)) {
          try {
            await this.specialityDuplicateValidation(
              this.paciente.studyInstanceUID,
              duplicacao.specialityID
            );
          } catch (e) {
            this.$root.$emit('hideLoading');

            await showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.error_validating_specialty'),
              text: e,
              confirmButtonText: 'OK'
            });
            return;
          }
        }

        this.showDuplicarExame = false;
      } finally {
        this.$root.$emit('hideLoading');
      }
    },

    async salvarExamesDuplicados(duplicacaoObj) {
      this.$root.$emit('showLoading')
      try {
        await this.salvarDuplicacaoAPI(duplicacaoObj)
        showDialog({
          icon: 'success',
          title: this.$t('dicom_plus.dialog_message.success'),
          text: this.$t('dicom_plus.dialog_message.duplicate_successfully'),
          confirmButtonText: 'OK'
        })
        this.showDuplicarExame = false
        this.duplicacoes = [{ specialityID: null, subSpeciality: null, requisicaoID: null, procedimento: null, deleted: false }]
      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.fail'),
          text: e,
          confirmButtonText: 'OK'
        })
      } finally {
        this.$root.$emit('hideLoading')
        this.$emit('refreshGrid')
      }
    },
    async desbloquearExame() {
      const dicomPlusID = this.exam.dicomPlusID;
      await this.removeAssignedUserToExam(dicomPlusID);
      this.$emit('refreshGrid')

    },
    async ignoreExamBackToGrid() {
      if (this.exam?.status !== 0) {
        this.$emit('close')
        return;
      }
      this.$root.$emit('showLoading')
      try {
        await this.desbloquearExame()
        await this.$nextTick()
      } finally {
        this.$root.$emit('hideLoading')
        this.$emit('close')
      }
    },
    async confirmarSairExame() {
      if (this.isDirty() && this.exam?.status !== CONSTANTS.DICOM_PLUS_STATUS.REVISADO) {
        await showDialog({
          title: this.$t('dicom_plus.dialog_message.confirmation'),
          text: this.$t('dicom_plus.dialog_message.confirm_exit'),
          confirmButtonText: this.$t('dicom_plus.yes'),
          denyButtonText: this.$t('dicom_plus.no'),
          icon: 'question',
          focusConfirm: false,
          focusDeny: true,
          confirmed: () => this.ignoreExamBackToGrid()
        })
      } else {
        this.$root.$emit('showLoading')
        if (this.exam?.status !== 0) {
          this.$emit('close')
          this.$root.$emit('hideLoading')
          return
        }
        await this.desbloquearExame()
        await this.$nextTick()
        this.$root.$emit('hideLoading')
        this.$emit('close')
      }
    },
    validarCamposComplementaresObrigatorios() {
      const obrigatorios = this.camposComplementares.filter((campo) => campo.required)
      const faltando = obrigatorios.filter((campo) => {
        const valor = this.formComplementares[campo.titulo]
        return valor === null || valor === undefined || String(valor).trim() === ''
      })
      return faltando
    },

    // Salvar dados
    async salvarDados() {
      const { nome, dataNascimento, sexo, patientID, studyInstanceUID, socialName } = this.paciente;

      // Validações básicas
      if (!nome || !nome.trim() || !dataNascimento || !sexo || !sexo.trim() || !this.estudo.especialidade) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.required_fields'),
          text: this.$t('dicom_plus.dialog_message.fill_data_with_asterisk'),
          confirmButtonText: 'OK'
        });
        return;
      }

      if (this.isExamEditable && this.isPhysicianFieldRequired && (!this.estudo.medicoID || String(this.estudo.medicoID).trim() === '')) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.required_fields'),
          text: this.$t('dicom_plus.dialog_message.fill_physician_us_for_ultrasound'),
          confirmButtonText: 'OK'
        });
        return;
      }

      if (!isDataValida(dataNascimento)) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.invalid_data'),
          text: this.$t('dicom_plus.dialog_message.invalid_date_of_birth'),
          confirmButtonText: 'OK'
        });
        return;
      }

      if (this.isCommentOverflow) {
        const maxCommentChars = this.MAX_COMMENT_CHARS.toLocaleString('pt-BR');
        const currentCharCount = this.currentCharCount.toLocaleString('pt-BR');
        const exceedChars = this.exceededChars.toLocaleString('pt-BR')
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.invalid_data'),
          text: this.$t('dicom_plus.dialog_message.invalid_comment_field', {
            limit: maxCommentChars,
            digited: currentCharCount,
            character: exceedChars
          }),
          confirmButtonText: 'OK'
        });
        return;
      }

      // Validação de CPF (se campo existir)
      const campoCpf = this.camposComplementares.find((campo) => campo.special === 1);
      if (campoCpf) {
        const valorCpf = this.formComplementares[campoCpf.titulo];
        if (valorCpf && valorCpf.trim() !== '' && !this.cpfValido) {
          showDialog({
            icon: 'warning',
            title: this.$t('dicom_plus.dialog_message.invalid_data'),
            text: this.$t('dicom_plus.dialog_message.invalid_cpf'),
            confirmButtonText: 'OK'
          });
          return;
        }
      }

      // Monta dadosComplementares a partir dos campos dinâmicos
      const dadosComplementaresJSON = {};
      this.camposComplementares.forEach((campo) => {
        dadosComplementaresJSON[campo.titulo] = this.formComplementares[campo.titulo];
      });

      const isExamNotExistForPayload = !!this.isExamNotExistGestorSaude;

      const tagsPlusLimpo = removeValoresVazios(dadosComplementaresJSON, ['requisicaoID']);
      tagsPlusLimpo.IsExamNotExistGestorSaude = !!this.formComplementares.isExamNotExistGestorSaude;

      const allDuplicates = (this.duplicacoes || []).map(d => ({
        specialityID: d && d.specialityID ? d.specialityID : null,
        subSpeciality: d && d.subSpeciality ? d.subSpeciality : null,
        requisicaoID: d && d.requisicaoID ? d.requisicaoID : null,
        portalSocId: d && d.portalSocId ? d.portalSocId : null,
        deleted: !!(d && d.deleted)
      }));

      const duplicatesToSend = allDuplicates.filter(item =>
        item.deleted === true ||
        item.specialityID !== null ||
        item.requisicaoID !== null ||
        item.subSpeciality !== null ||
        item.portalSocId !== null
      );

      const duplicateSpecialitiesPayload = duplicatesToSend.length ? duplicatesToSend : null;

      const novoStatus = this.exam.status === CONSTANTS.DICOM_PLUS_STATUS.PENDENTE
        ? CONSTANTS.DICOM_PLUS_STATUS.REVISADO
        : this.exam.status;

      const tipoAvaliacaoOncologiaUpdate =  this.exam.prioridade === CONSTANTS.DICOM_PLUS_PRIORIDADE.EMERGENCIA
        ? null
        : this.estudo.tipoAvaliacaoOncologia;

      const diagnosticoHipoteseUpdate =  this.exam.prioridade === CONSTANTS.DICOM_PLUS_PRIORIDADE.EMERGENCIA
        ? null
        : this.estudo.diagnosticoHipotese;

      const payload = {
        dicomPlusID: this.exam.dicomPlusID,
        studyInstanceUID,
        accessionNumber: this.exam.accessionNumber,
        stationName: this.exam.stationName,
        fonteID: this.exam.fonteID,
        modality: this.estudo.modality || this.exam.modality,
        patientName: nome.trim(),
        patientID,
        patientBirthDate: dateBrToInt(dataNascimento),
        patientSex: sexo.trim(),
        patientSocialName: socialName && socialName.trim() ? socialName.trim() : null,
        studyDescription: this.estudo.studyDescription || this.exam.studyDescription,
        patientComments: this.estudo.comentarios || this.exam.patientComments || null,
        tituloLaudo: this.exam.tituloLaudo || null,
        status: novoStatus,
        studyDate: this.estudo.studyDate || this.exam.studyDate,
        studyTime: this.estudo.studyTime || this.exam.studyTime,
        requestingPhysicianName: this.exam.requestingPhysicianName,
        patientWeight: this.exam.patientWeight,
        token: this.exam.token,
        especialidadeID: this.estudo.especialidade || this.exam.especialidade,
        subEspecialidade: this.estudo.subEspecialidade || this.exam.subEspecialidade,
        contraste: this.estudo.contraste || this.exam.contraste,
        contrasteVia: this.estudo.contrasteVia || this.exam.contrasteVia,
        contrasteTipo: this.estudo.contrasteTipo || this.exam.contrasteTipo,
        tipoAvaliacaoOncologia: tipoAvaliacaoOncologiaUpdate,
        diagnosticoHipotese: diagnosticoHipoteseUpdate,
        trauma: this.estudo.trauma || this.exam.trauma,
        avc: this.estudo.avc || this.exam.avc,
        leito: this.estudo.leito || this.exam.leito,
        oncologico: this.estudo.oncologico || this.exam.oncologico,
        prioridade: this.estudo.prioridade || this.exam.prioridade || CONSTANTS.DICOM_PLUS_PRIORIDADE.ROTINA,
        mamografia: JSON.stringify(this.mamografia) || '',
        tagsPlus: Object.keys(tagsPlusLimpo).length === 0 ? null : JSON.stringify(tagsPlusLimpo),
        duplicateSpecialities: duplicateSpecialitiesPayload,
        procedimentoID: Number(this.procedimentoID) || null,
        requisicaoID: Number(this.requisicaoID) || null,
        isExamNotExistGestorSaude: isExamNotExistForPayload,
        patientAge: this.exam.idade,
        enviaParaGSaudeApp: this.exam.enviaParaGSaudeApp,
        medicoID: this.estudo.medicoID || this.exam.medicoID || null,
        nomeMedico: this.estudo.nomeMedico || this.exam.nomeMedico || ''
      };

      if (this.selectedFichaId) {
        payload.portalSocId = this.selectedFichaId;
      }

      this.$root.$emit('showLoading');
      try {
        const modality = this.estudo.modality || this.exam.modality;

        if (modality === 'MG') {
          await this.gerarPDF();
      //    throw new Error(this.$t('dicom_plus.dialog_message.fail_generate_pdf'))
        }

        await this.updatePaciente(payload);
        this.$root.$emit('hideLoading');

        showDialog({
          icon: 'success',
          title: this.$t('dicom_plus.dialog_message.success'),
          text: this.$t('dicom_plus.dialog_message.registration_updated_succesfully'),
          confirmButtonText: 'OK',
          confirmed: () => {
            this.storeInitialState();
            this.$emit('refreshGrid');
            this.$emit('close');
          }
        });
      } catch (error) {
        this.$root.$emit('hideLoading');
        if (error && error.message && error.message.includes('gestor saúde')) {
          showDialog({
            icon: 'warning',
            title: this.$t('dicom_plus.dialog_message.confirm_save'),
            text: error,
            confirmButtonText: this.$t('dicom_plus.dialog_message.continue'),
            denyButtonText: this.$t('dicom_plus.dialog_message.cancel'),
            confirmed: async () => {
              this.$root.$emit('showLoading');
              try {
                await this.updatePaciente(payload, true);
                showDialog({
                  icon: 'success',
                  title: this.$t('dicom_plus.dialog_message.success'),
                  text: this.$t('dicom_plus.dialog_message.registration_updated_succesfully'),
                  confirmButtonText: 'OK',
                  confirmed: () => {
                    this.storeInitialState();
                    this.$emit('refreshGrid');
                    this.$emit('close');
                  }
                });
              } catch (error) {
                const mensagemErro = extrairMensagemErroApi(error, this.$t('error.unexpected_error_occurred'));
                const isPedidoMedicoPendente = isErroPedidoMedico(mensagemErro);
                showDialog({
                  icon: isPedidoMedicoPendente ? 'warning' : 'error',
                  title: isPedidoMedicoPendente
                    ? this.$t('medical_order_required_title')
                    : this.$t('dicom_plus.dialog_message.error_validating_data'),
                  text: mensagemErro,
                  confirmButtonText: 'OK'
                });
              } finally {
                this.$root.$emit('hideLoading');
              }
            }
          });
        } else {
          const mensagemErro = extrairMensagemErroApi(error, this.$t('error.unexpected_error_occurred'))
          const isPedidoMedicoPendente = isErroPedidoMedico(mensagemErro)
          showDialog({
            icon: isPedidoMedicoPendente ? 'warning' : 'error',
            title: isPedidoMedicoPendente
              ? this.$t('medical_order_required_title')
              : this.$t('dicom_plus.dialog_message.error_validating_data'),
            text: mensagemErro,
            confirmButtonText: 'OK'
          });
        }
      }
    },
    // Validação de dados
    async onDataNascimentoInput(data) {
      const { masked, isValid } = aplicarMascaraEValidarData(data.target.value)
      this.paciente.dataNascimento = masked
      this.dataNascimentoValida = isValid

      if (isValid) {
        const [day, month, year] = masked.split('/')
        const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        const result = await this.getPatientAge(dateStr)
        this.exam.idade = result.data || ''
      } else {
        this.exam.idade = ''
      }
    },
    onTelefoneInput(event) {
      const valor = aplicarMascaraTelefone(event.target.value)
      this.mamografia.telefone = valor
    },
    // Anexar arquivos
    async abrirModalAnexarArquivos(tipo = '') {
      await this.buscarListaDeArquivos()
      this.tipoAnexo = tipo
      this.showAnexarArquivos = true
    },
    fecharModalAnexarArquivos() {
      this.showAnexarArquivos = false
      this.tipoAnexo = ''
    },
    existePedidoMedicoVinculado(arquivosEmLote = []) {
      const pedidoMedico = CONSTANTS.DICOM_PLUS_TIPO_ANEXO.PEDIDO_MEDICO
      return [...(this.savedFiles || []), ...(arquivosEmLote || [])].some(
        (file) => Number(file.tipoAnexo) === pedidoMedico
      )
    },
    pedidoMedicoObrigatorioPendente(arquivosEmLote = []) {
      if (!this.exam?.exigePedidoMedico) return false
      if (this.existePedidoMedicoVinculado(arquivosEmLote)) return false
      showDialog({
        icon: 'warning',
        title: this.$t('medical_order_required_title'),
        text: this.$t('medical_order_required'),
        confirmButtonText: 'OK'
      })
      return true
    },
    async salvarArquivos({ files }) {
      if (this.pedidoMedicoObrigatorioPendente(files)) {
        return
      }
      const dicomPlusID = this.exam.dicomPlusID
      const filesPayload = []
      try {
        this.$root.$emit('showLoading')
        for (const file of files) {
          const urlInfo = await this.criarUrlAssinadaUploadCloud(file)
          if (!urlInfo.success) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail'),
              text: urlInfo.message,
              confirmButtonText: 'OK'
            })
            continue
          }

          const uploadResult = await this.uploadExameStorage(urlInfo.uploadUrl, file.file)
          if (!uploadResult.success) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail_save_storage'),
              text: uploadResult.message,
              confirmButtonText: 'OK'
            })
            continue
          }

          filesPayload.push({
            linkStorage: urlInfo.publicUrl,
            tipoAnexo: file.tipoAnexo
          })
        }

        if (filesPayload.length) {
          const payload = {
            dicomPlusID,
            files: filesPayload
          }
          const resultado = await this.salvarAnexoLocal(payload)
          if (!(resultado && resultado.success)) {
            showDialog({
              icon: 'error',
              title: this.$t('dicom_plus.dialog_message.fail'),
              text: resultado.message || this.$t('dicom_plus.dialog_message.fail_save_storage'),
              confirmButtonText: 'OK'
            })
          } else {
            showDialog({
              icon: 'success',
              title: this.$t('dicom_plus.dialog_message.success'),
              text: this.$t('dicom_plus.dialog_message.files_saved_succesfully'),
              confirmButtonText: 'OK'
            })
          }
        }
      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.fail_attach_file'),
          text: e,
          confirmButtonText: 'OK'
        })
      } finally {
        await this.buscarListaDeArquivos()
        this.$refs.importFilesModal && this.$refs.importFilesModal.clearImportedFiles && this.$refs.importFilesModal.clearImportedFiles()
        this.$root.$emit('hideLoading')
      }
    },
    async confirmaExcluirArquivoSalvo(id){
      await showDialog({
          title: this.$t('dicom_plus.dialog_message.confirmation'),
          text: this.$t('dicom_plus.dialog_message.confirm_attachment_deletion'),
          confirmButtonText: this.$t('dicom_plus.yes'),
          denyButtonText: this.$t('dicom_plus.no'),
          icon: 'question',
          focusConfirm: false,
          focusDeny: true,
          confirmed: () => this.excluirArquivoSalvo(id)
        })
    },
    async excluirArquivoSalvo(id) {
      try {
        this.$root.$emit('showLoading')
        await this.deleteFiles(id)
        await this.buscarListaDeArquivos(this.examAnexo)
        showDialog({
          icon: 'success',
          title: this.$t('dicom_plus.dialog_message.success'),
          text: this.$t('dicom_plus.dialog_message.files_removed_succesfully'),
          confirmButtonText: 'OK'
        })
      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.delete_error'),
          text: e,
          confirmButtonText: 'OK'
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    // Carregar dados
    async buscarPaciente() {
      const dicomPlusID = this.exam.dicomPlusID
      if (!dicomPlusID) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.dialog_message.warn'),
          text: this.$t('dicom_plus.dialog_message.dicomplusID_not_informed'),
          confirmButtonText: 'OK'
        })
        return
      }

      try {
        this.$root.$emit('showLoading')
        const result = await this.getDadosPorPaciente({ dicomPlusID })
        const dados = Array.isArray(result) && result.length > 0 ? result[0] : {}
        Object.assign(this.estudo, {
          unidade: dados?.unidade || dados?.sourceRequestorName || '',
          especialidade: dados?.especialidadeID || '',
          subEspecialidade: dados?.subEspecialidade || '',
          contraste: dados?.contraste || '',
          contrasteVia: dados?.contrasteVia || '',
          contrasteTipo: dados?.contrasteTipo || '',
          trauma: dados?.trauma || '',
          avc: dados?.avc || '',
          leito: dados?.leito || '',
          oncologico: dados?.oncologico || '',
          comentarios: dados?.comentarios || dados?.patientComments || '',
          prioridade: dados?.prioridade || '',
          modality: dados?.categoria || dados?.modality || '',
          studyDescription: dados?.estudo || dados?.studyDescription || '',
          studyDate: dados?.estudo?.studyDate || dados?.studyDate || '',
          studyTime: dados?.estudo?.studyTime || dados?.studyTime || '',
          medicoID: dados?.medicoID || '',
          nomeMedico: dados?.nomeMedico || ''
        })
        Object.assign(this.paciente, {
          nome: dados?.paciente || '',
          dataNascimento: dados?.dataNascimento || '',
          sexo: dados?.sexo || '',
          socialName: dados?.socialName || '',
          patientID: dados?.patientID || '',
          dicomPlusID: dados?.dicomPlusID || '',
          studyInstanceUID: dados?.studyInstanceUID,
          exameID: dados?.exameID || ''
        })
        this.procedimentoID = dados.procedimentoID || ''
        if (dados.mamografia) {
          let dadosMamografia = dados.mamografia
          if (typeof dadosMamografia === 'string') {
            try {
              dadosMamografia = JSON.parse(dadosMamografia)
            } catch (e) {
              dadosMamografia = {}
            }
          }
          Object.keys(this.mamografia).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(dadosMamografia, key)) {
              this.$set(this.mamografia, key, dadosMamografia[key])
            }
          })
        }
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.search_data_error'),
          text: error,
          confirmButtonText: 'OK'
        })
      } finally {
        this.$emit('refreshGrid')
        this.$root.$emit('hideLoading')
      }
    },
    async carregarEspecialidades() {
      const modality = this.exam?.categoria || this.estudo?.categoria || ''
      if (!modality) {
        this.estudo.especialidadeOptions = []
        return
      }
      const especialidades = await this.getSpecialityList(modality)

      const especialidadesLimpa = (especialidades || []).map(e => ({
        value: e.value,
        label: e.label,
        procedimentos: String(e.procedimentos || '').split(',').map(p => p.trim())
      }));

      this.estudo.especialidadeOptions = especialidadesLimpa
      this.estudo.especialidadeDuplicarOptions = especialidadesLimpa

      if (this.estudo.especialidade) {
        const sel = especialidadesLimpa.find((e) => String(e.value) === String(this.estudo.especialidade))
        if (sel) {
          this.especialidadeSearch = sel.label
        } else {
          this.especialidadeSearch = ''
        }
      }
    },
    async buscarTiposDeContrasteEViaAdministracao() {
      const { via, tipo } = await this.getContrastTypes()
      this.estudo.tipoContrasteOptions = tipo
      this.estudo.viaAdministracaoOptions = via
    },
    async buscarTiposDeAvaliacaoOncologiaEDiagnostico() {
      const { tipoAvaliacaoOncologia, diagnosticoHipotese } = await this.buscarTipoAvaliacaoOncologiaEDiagnostico()
      this.estudo.tipoAvaliacaoOncologiaOptions = tipoAvaliacaoOncologia
      this.estudo.diagnosticoHipoteseOptions = diagnosticoHipotese
    },
    buscarTipoAvaliacaoOncologiaEDiagnostico(){
      const tipoAvaliacaoOncologia = Object.values(CONSTANTS.TIPO_AVALIACAO_ONCOLOGIA)
      const diagnosticoHipotese = Object.values(CONSTANTS.DIAGNOSTICO_HIPOTESTE)

      return { tipoAvaliacaoOncologia, diagnosticoHipotese }
    },
    async buscarMedicosPorEspecialidade() {
      const specialityID = this.estudo.especialidade || null;
      const fonteID = this.exam?.fonteID;
      const modalityID = this.exam?.categoria || '';

      if (!specialityID) {
        this.medicoUSOptions = [];
        return;
      }

      const res = await this.getPhysicianBySpeciality(specialityID, fonteID, modalityID);
      this.medicoUSOptions = res.listaMedicoUS || [];
    },
    async buscarPrioridades() {
      const res = await this.getPriority()
      let prioridadesOrdenados = res.sort((a, b) => a.label.localeCompare(b.label))
      if (this.exam && this.exam.fonteEmergenciaOpcional !== true
        || this.exam.categoria !== CONSTANTS.DICOM_PLUS_MODALIDADE.TC) {
        prioridadesOrdenados = prioridadesOrdenados.filter(
          p => p.label.toLowerCase() !== 'emergência' && p.label.toLowerCase() !== 'emergencia'
        )
      }
      this.estudo.prioridadeOptions = prioridadesOrdenados
    },
    async buscarAnexoTipo() {
      this.anexoTipoOptions = await this.getFileTypes()
    },
    async buscarListaDeArquivos() {
      const dicomPlusID = this.exam?.dicomPlusID
      const res = await this.getFileList(dicomPlusID)
      this.savedFiles = res
      this.attachedFilesCount = this.savedFiles.length
    },
    // Autocomplete da especialidade
    abrirDropdownEspecialidade() {
      this.dropdownEspecialidadeAberto = true
      this.filtrarEspecialidades()
    },
    filtrarEspecialidades() {
      const termo = (this.especialidadeSearch || '').toLowerCase()
      if (!termo) {
        this.especialidadeFiltrada = this.estudo.especialidadeOptions
      } else {
        this.especialidadeFiltrada = this.estudo.especialidadeOptions.filter((op) =>
          op.label
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(termo.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
        )
      }
      this.dropdownEspecialidadeAberto = true
    },
    selecionarEspecialidade(op) {
      this.estudo.especialidadeID = op.value
      this.especialidadeSearch = op.label
      this.dropdownEspecialidadeAberto = false
    },
    fecharDropdownEspecialidade(e) {
      const input = this.$el.querySelector('#especialidadeOptions')
      const dropdown = this.$el.querySelector('.dropdown-list')
      if (e && input && dropdown && !input.contains(e.target) && !dropdown.contains(e.target)) {
        this.dropdownEspecialidadeAberto = false
      }
    },
    fecharDropdownEspecialidadeEsc(e) {
      if (e.key === 'Escape' && this.dropdownEspecialidadeAberto) {
        this.dropdownEspecialidadeAberto = false
      }
    },
    validarEspecialidadeInput() {
      const termo = (this.especialidadeSearch || '').trim().toLowerCase()
      const encontrada = this.estudo.especialidadeOptions.find((op) => op.label.toLowerCase() === termo)
      if (!encontrada) {
        this.especialidadeSearch = ''
        this.estudo.especialidade = ''
      } else {
        this.estudo.especialidade = encontrada.value
        this.especialidadeSearch = encontrada.label
      }
      this.dropdownEspecialidadeAberto = false
    },
    // Duplicar exames
    abrirDuplicarExameModal() {
      this.validarEspecialidadeInput()

      if (!this.estudo.especialidade) {
        showDialog({
          title: this.$t('dicom_plus.dialog_message.atention'),
          text: this.$t('dicom_plus.dialog_message.fill_speciality_before_duplicate'),
          confirmButtonText: 'OK',
          icon: 'warning',
          focusConfirm: true
        })
        return
      }
       if (this.exam?.enviaParaGSaudeApp && !this.isExamNotExistGestorSaude) {
        const availableDuplicacoes = (this.duplicacoes || []).filter(d => {
          if (d.deleted) return false;
          const hasRequisicao = d.requisicaoID !== undefined && d.requisicaoID !== null && String(d.requisicaoID).trim() !== '';
          const hasSpeciality = d.specialityID !== undefined && d.specialityID !== null && String(d.specialityID).trim() !== '';
          const hasProcedimento = d.procedimento !== undefined && d.procedimento !== null && String(d.procedimento).trim() !== '';
          return hasRequisicao || hasSpeciality || hasProcedimento;
        }).length;

        if (availableDuplicacoes <= 1) {
          showDialog({
            title: this.$t('dicom_plus.dialog_message.atention'),
            text: this.$t('dicom_plus.dialog_message.no_exams_to_duplicate'),
            confirmButtonText: 'OK',
            icon: 'warning',
            focusConfirm: true
          });
          return;
        }
      }
      this.showDuplicarExame = true
    },
    adicionarDuplicacao() {
      this.duplicacoes.push({ specialityID: '', subSpeciality: null, requisicaoID: null, procedimento: null, deleted: false })
    },
    removerDuplicacao(itemOrIdx) {
      let idx = -1;
      if (typeof itemOrIdx === 'number') {
        idx = itemOrIdx;
      } else if (itemOrIdx && typeof itemOrIdx === 'object') {
        idx = this.duplicacoes.indexOf(itemOrIdx);
      }
      if (idx === -1) return;

      const item = this.duplicacoes[idx];
      if (!item) return;

      const hasServerId = !!(item.requisicaoID || item.id || (item.specialityID && String(item.specialityID).trim() !== ''));

      if (hasServerId) {
        const updated = { ...item, deleted: true };
        if (this.$set) {
          this.$set(this.duplicacoes, idx, updated);
        } else {
          this.duplicacoes.splice(idx, 1, updated);
        }
      } else {
        this.duplicacoes.splice(idx, 1);
      }
    },

    // Abrir visualizador de exame
    openExamXView(url) {
      window.open(url, '_blank')
    },
    async handleGetExamXView() {
      const studyInstanceUID = this.paciente.studyInstanceUID
      const res = await this.getExamXView(studyInstanceUID)
      if (!res?.exameURL?.length) return
      this.openExamXView(res.exameURL)
    },
    // Dados complementares
    async buscarCamposComplementares() {
      const fonteID = this.exam.fonteID
      let campos = await this.getDadosComplementares(fonteID)
      campos = campos.sort((a, b) => a.posicao - b.posicao)
      this.camposComplementares = campos

      let dadosSalvos = this.exam.dadosComplementares || this.exam.tagsPlus || {}
      if (typeof dadosSalvos === 'string') {
        try {
          dadosSalvos = JSON.parse(dadosSalvos)
        } catch (e) {
          dadosSalvos = {}
        }
      }

      campos.forEach((campo) => {
        let valor = dadosSalvos[campo.titulo] ?? ''
        if ((campo.special === 1 || campo.special === 2) && typeof valor === 'number') {
          valor = String(valor)
        }
        this.$set(this.formComplementares, campo.titulo, valor)
      })

      this.isExamNotExistGestorSaude = !!dadosSalvos.IsExamNotExistGestorSaude

      if (dadosSalvos.requisicaoID !== undefined && dadosSalvos.requisicaoID !== null && String(dadosSalvos.requisicaoID).trim() !== '') {
        this.requisicaoID = String(dadosSalvos.requisicaoID)
        this.gsaudeappText = String(dadosSalvos.requisicaoID)
      } else {
        this.requisicaoID = ''
        this.gsaudeappText = ''
      }
    },
    onCampoInput(titulo, event, campo) {
      let valor = event.target.value

      if (campo.special === CONSTANTS.DICOM_PLUS_FONTE_CABECALHO_TAG.CPF) {
        valor = aplicarMascaraCpf(String(valor))
        this.cpfValido = validarCpf(valor)
        event.target.value = valor
      }
      if (campo.special === CONSTANTS.DICOM_PLUS_FONTE_CABECALHO_TAG.DATA_LAUDO) {
        valor = aplicarMascaraDeData(String(valor))
        this.dataNascimentoValida = isDataValida(valor)
        event.target.value = valor
      }

      this.$set(this.formComplementares, titulo, valor)
    },
    widthByMaxLength(maxLength) {
      const ml = Number(maxLength) || 20
      const width = ml * 1.6
      const max = 90
      return `${Math.min(width, max)}ch`
    },
    abrirHelperCampo(texto){
      if (texto && texto.trim().length > 0) {
      Swal.fire({
        icon: 'info',
        html: texto,
        confirmButtonText: 'OK',
        width: 500
      });
    }},

    async handleDownloadLink(dicomPlusFileID) {
      this.$root.$emit('showLoading')
      try {
        const result = await this.criarUrlAssinadaDownloadCloud(dicomPlusFileID)

        if (result) {
          window.open(result.url, '_blank')
        } else {
          showDialog({
            icon: 'error',
            title: this.$t('dicom_plus.dialog_message.download_error'),
            text: this.$t('dicom_plus.dialog_message.download_error_link'),
            confirmButtonText: 'OK'
          })
        }
      } catch (error) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.download_error'),
          text: error,
          confirmButtonText: 'OK'
        })
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    storeInitialState() {
      this.dirtyBit = JSON.stringify(this.getCleanState())
    },
    isDirty() {
      const currentState = JSON.stringify(this.getCleanState())
      return currentState !== this.dirtyBit
    },
    getCleanState() {
      return {
        paciente: { ...this.paciente },
        estudo: {
          unidade: this.estudo.unidade,
          especialidade: this.estudo.especialidade,
          subEspecialidade: this.estudo.subEspecialidade,
          contraste: this.estudo.contraste,
          contrasteVia: this.estudo.contrasteVia,
          contrasteTipo: this.estudo.contrasteTipo,
          trauma: this.estudo.trauma,
          avc: this.estudo.avc,
          leito: this.estudo.leito,
          oncologico: this.estudo.oncologico,
          comentarios: this.estudo.comentarios,
          prioridade: this.estudo.prioridade,
          modality: this.estudo.modality,
          studyDescription: this.estudo.studyDescription,
          studyDate: this.estudo.studyDate,
          studyTime: this.estudo.studyTime,
          medicoID: this.estudo.medicoID
        },
        mamografia: { ...this.mamografia },
        formComplementares: { ...this.formComplementares },
        duplicacoes: JSON.parse(JSON.stringify(this.duplicacoes))
      }
    },
    prepareElementForPDF(element) {
      const clone = element.cloneNode(true);

      // Processar inputs de texto
      const textInputs = clone.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]');
      textInputs.forEach(input => {
          const value = input.value || '';

          const valueDiv = document.createElement('div');
          valueDiv.className = value ? 'pdf-field' : 'pdf-field empty';
          valueDiv.textContent = value;

          input.parentNode.replaceChild(valueDiv, input);
      });

      // Processar textareas
      const textareas = clone.querySelectorAll('textarea');
      textareas.forEach(textarea => {
          const value = textarea.value || '';

          const valueDiv = document.createElement('div');
          valueDiv.className = value ? 'pdf-field' : 'pdf-field empty';
          valueDiv.style.minHeight = '80px';
          valueDiv.style.whiteSpace = 'pre-wrap';
          valueDiv.textContent = value;

          textarea.parentNode.replaceChild(valueDiv, textarea);
      });

      // Processar selects
      const selects = clone.querySelectorAll('select');
      selects.forEach(select => {
          const selectedOption = select.options[select.selectedIndex];
          const value = selectedOption ? selectedOption.text : '';

          const valueDiv = document.createElement('div');
          valueDiv.className = value ? 'pdf-field' : 'pdf-field empty';
          valueDiv.textContent = value;

          select.parentNode.replaceChild(valueDiv, select);
      });

      // Processar checkboxes - tratamento especial
      const checkboxGroups = clone.querySelectorAll('.checkbox-group');
      checkboxGroups.forEach(group => {
          const checkbox = group.querySelector('input[type="checkbox"]');
          const label = group.querySelector('label');

          if (checkbox && label) {
              const isChecked = checkbox.checked;
              const labelText = label.textContent;

              // Criar container para o checkbox no PDF
              const pdfContainer = document.createElement('div');
              pdfContainer.className = 'pdf-checkbox-container';

              // Criar o checkbox visual
              const checkboxDiv = document.createElement('div');
              checkboxDiv.className = isChecked ? 'pdf-checkbox checked' : 'pdf-checkbox';

              // Criar o label
              const labelDiv = document.createElement('div');
              labelDiv.className = 'pdf-checkbox-label';
              labelDiv.textContent = labelText;

              // Montar o elemento
              pdfContainer.appendChild(checkboxDiv);
              pdfContainer.appendChild(labelDiv);

              // Substituir o grupo original
              group.parentNode.replaceChild(pdfContainer, group);
          }
      });

      // Remover botões
      const buttons = clone.querySelector('.buttons');
      if (buttons) buttons.remove();

      return clone;
    },
    async gerarPDF(){
      if (this.isMamografiaEditable)
      {
        try
        {
          const tabBefore = this.activeTab;
          const name = `mamografia_${this.paciente.nome}.pdf`;


          this.activeTab = 'mamografia';

          await this.$nextTick();

          const tabVm = this.$refs.tabMamografiaPDF
          const elemento =
            tabVm && tabVm.$refs && tabVm.$refs.pdfRoot ? tabVm.$refs.pdfRoot : tabVm
          const pdfElement = this.prepareElementForPDF(elemento);

          const options = {
              margin:       0,
              filename:     name,
              image:        { type: 'jpeg', quality: 0.98 },
              html2canvas:  { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
              jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' },
              pagebreak:    { mode: 'avoid-all' },

          };

          this.activeTab = tabBefore;

          const filePDF = await html2pdf().from(pdfElement).set(options).outputPdf('blob');

          filePDF.name = options.filename;
          return this.salvarPDFMamografia(filePDF);
        }
        catch(e)
        {
          return false;
        }

      }
    },
    async salvarPDFMamografia(file) {
      const dicomPlusID = this.exam.dicomPlusID
      const filesPayload = []
      try {
        const urlInfo = await this.criarUrlAssinadaUploadCloud(file)
        if (!urlInfo.success) {
          return false;
        }

        const uploadResult = await this.uploadExameStorage(urlInfo.uploadUrl, file)
        if (!uploadResult.success) {
          return false;
        }

        filesPayload.push({
          linkStorage: urlInfo.publicUrl,
          tipoAnexo: 2
        })

        const payload = {
          dicomPlusID,
          files: filesPayload
        }

        await this.salvarAnexoLocal(payload)
        return true

      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.fail_attach_file'),
          text: e,
          confirmButtonText: 'OK'
        })
        return false
      }
    },
    abrirGSaude() {
      this.mostrarGSaude = true;
    },
    async buscarDadosGestorSaude(solicitacaoId) {
      this.$root.$emit('showLoading')
      try {
        const pacienteCpf = this.formComplementares.CPF;
        const pacienteDataNascimento =  this.exam.dataNascimento;
        const modalityID = this.exam?.categoria;
        const fonteID = this.exam?.fonteID;
        const dados = await this.buscarDadosPacienteGestorSaude({
          solicitacaoId,
          modalityID,
          fonteID,
          pacienteCpf,
          pacienteDataNascimento,

        });
        this.objetoPaciente = dados;
        this.mostrarGSaude = true;
      } catch (e) {
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.no_data_found'),
          text: e,
          confirmButtonText: 'OK'
        })
        this.mostrarGSaude = false;
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    async confirmaAtualizarDados(payload){
      await showDialog({
        title: this.$t('dicom_plus.dialog_message.confirmation'),
        text: this.$t('dicom_plus.gestor_saude.confirm_replace'),
        denyButtonText: this.$t('dicom_plus.no'),
        confirmButtonText: this.$t('dicom_plus.gestor_saude.replace'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: () => this.atualizarDadosGestorSaude(payload)
      })

    },
    atualizarDadosGestorSaude(payload){
      try {
        for (const [index, especialidade] of payload.especialidades.entries()) {
          if (especialidade.especialidadeID) {
            const match = this.estudo.especialidadeDuplicarOptions.find(
              opt => opt.value === especialidade.especialidadeID
            );

            if (!match) continue;

            this.estudo.especialidade = match.value
            this.especialidadeSearch = match?.label || '';

            payload.especialidades.splice(index, 1);
            this.requisicaoID = especialidade.requisicaoId;
            break;
          }
        }

        if (!this.especialidadeSearch && payload.especialidades && payload.especialidades.length > 0)
        {
           const especialidade = payload.especialidades[0];

           this.requisicaoID = especialidade.requisicaoId;

           if (especialidade.procedimentosEspecialidade != null &&
            Array.isArray(especialidade.procedimentosEspecialidade)) {

            this.estudo.especialidadeOptions = [];

            especialidade.procedimentosEspecialidade.forEach((proc) => {
              this.estudo.especialidadeOptions.push({
                value: proc.specialityId,
                label: proc.specialityName,
              });
            });
           }

           payload.especialidades.splice(0, 1);

        }

        const especialidadeInput = this.$el.querySelector('#especialidadeOptions')
        if (especialidadeInput) {
          especialidadeInput.disabled = this.especialidadeSearch !== ''
        }

        const mappedDuplicacoes = [];

        for (const raw of payload.especialidades) {
          mappedDuplicacoes.push({
            specialityID: raw.especialidadeID || '',
            subSpeciality: '',
            requisicaoID: raw.requisicaoId,
            procedimento: raw.procedimentoNome,
            procedimentoCodigo: raw.procedimentoCodigo,
            procedimentosEspecialidade : raw.procedimentosEspecialidade,
            deleted: false
          });
        }

        // Se houver duplicacoes mapeadas, atualiza this.duplicacoes e abre modal
        if (mappedDuplicacoes.length) {
          this.duplicacoes = mappedDuplicacoes;
          this.showDuplicarExame = true;
        } else {
          // se não houver duplicações, garante valor default (linha vazia)
          this.duplicacoes = [{ specialityID: '', subSpeciality: '', requisicaoID: '', procedimento: '', deleted: false }];
        }

        // Aplica demais campos básicos do paciente (nome, cpf, dataNascimento) se existirem no payload
        if (payload.nome !== undefined && payload.nome !== null && String(payload.nome).trim() !== '') {
          this.paciente.nome = payload.nome;
          this.formComplementares.Paciente = payload.nome;
        }
        if (payload.cpf !== undefined && payload.cpf !== null && String(payload.cpf).trim() !== '' && validarCpf(payload.cpf)) {
          this.formComplementares.CPF = aplicarMascaraCpf(payload.cpf);
        }
        if (payload.dataNascimento !== undefined && payload.dataNascimento !== null && String(payload.dataNascimento).trim() !== '') {
          const dataBR = formatDateBR(payload.dataNascimento);
          if (isDataValida(dataBR)) {
            this.paciente.dataNascimento = dataBR;
          }
        }
        if (payload.comentarios !== undefined &&
          payload.comentarios !== null &&
          String(payload.comentarios).trim() !== '')
          {
            this.estudo.comentarios = payload.comentarios;
          }
        this.mostrarGSaude = false;
      } catch (e) {
        console.error('Erro ao confirmar atualização de dados e aplicar especialidades:', e);
      }
    },
    atualizarDadosPaciente({nome, cpf, dataNascimento, requisicaoID, especialidade}) {
      if (nome !== undefined && nome !== null && String(nome).trim() !== '') {
        this.paciente.nome = nome;
        this.formComplementares.Paciente = nome;
      }
      if (
        cpf !== undefined &&
        cpf !== null &&
        String(cpf).trim() !== '' &&
        validarCpf(cpf)
      ) {
        this.formComplementares.CPF = aplicarMascaraCpf(cpf);
      }
      if (
        dataNascimento !== undefined &&
        dataNascimento !== null &&
        String(dataNascimento).trim() !== ''
      ) {
        const dataBR = formatDateBR(dataNascimento);
        if (isDataValida(dataBR)) {
          this.paciente.dataNascimento = dataBR;
        }
      }
      if (requisicaoID !== undefined && requisicaoID !== null && String(requisicaoID).trim() !== '' && requisicaoID !== 0) {
        this.requisicaoID = requisicaoID;
      }
      if (especialidade !== undefined && especialidade !== null && especialidade !== 0) {
        this.especialidade = especialidade;
      };
    },
    async abrirSoc(campo) {
      this.$root.$emit('showLoading')
      try {
        this.campoSocAtivo = campo;
        const cpf = campo;
        const fonteID = this.exam?.fonteID;
        const patientName = this.paciente.nome;
        const { items, total, pageCount } = await this.getSocFiles({
          cpf: cpf.replace(/\D/g, ''),
          page: this.socPage,
          pageSize: this.socPageSize,
          fonteID,
          patientName,
          allFiles: this.allFilesSoc
        });
        this.socItems = items;
        this.socTotal = total;
        this.socPageCount = pageCount;
        this.mostrarSoc = true;
      } catch (e){
        showDialog({
          icon: 'warning',
          title: this.$t('dicom_plus.no_data_found'),
          text: e.response?.data?.errors || this.$t('dicom_plus.soc.no_files_for_CPF'),
          confirmButtonText: 'OK'
        })
      } finally{
        this.$root.$emit('hideLoading')
      }
    },
    async onSelecionarFichasConfirmation(selectedItems) {
      if (!selectedItems || !Array.isArray(selectedItems) || selectedItems.length === 0) return;
      await showDialog({
        title: this.$t('dicom_plus.dialog_message.confirmation'),
        text: this.$t('dicom_plus.soc.confirm_select_soc_file'),
        denyButtonText: this.$t('dicom_plus.no'),
        confirmButtonText: this.$t('dicom_plus.soc.select') || this.$t('dicom_plus.yes'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: () => this.onSelecionarFichas(selectedItems)
      })
    },

    onSelecionarFichas(items) {
      try {
        if (!items || !items.length) return;

        const dadosSoc = items[0];
        this.selectedFichaId = dadosSoc.portalSocId;
        this.mostrarSoc = false;

        if (dadosSoc.especialidadeCodigo && dadosSoc.especialidadeNome) {
          this.especialidadeSearch = dadosSoc.especialidadeNome;
          this.estudo.especialidade = dadosSoc.especialidadeCodigo;
        }

        const others = items.slice(1);
        if (others.length) {
          const mappedDuplicacoes = others.map((raw) => ({
            specialityID: raw.especialidadeCodigo || '',
            subSpeciality: '',
            requisicaoID: null,
            procedimento: raw.especialidadeNome || '',
            procedimentoCodigo: raw.procedimentoCodigo || null,
            procedimentosEspecialidade: raw.procedimentosEspecialidade || null,
            portalSocId: raw.portalSocId || null,
            deleted: false
          }));

          this.duplicacoes = mappedDuplicacoes.length ? mappedDuplicacoes : [{ specialityID: '', subSpeciality: '', requisicaoID: '', procedimento: '', deleted: false }];
          this.showDuplicarExame = true;
        } else {
          this.duplicacoes = [{ specialityID: '', subSpeciality: '', requisicaoID: '', procedimento: '', deleted: false }];
        }

         if (dadosSoc) {
          if (dadosSoc.name !== undefined && dadosSoc.name !== null && String(dadosSoc.name).trim() !== '') {
            this.paciente.nome = dadosSoc.name;
          }

          if (dadosSoc.cpf !== undefined && dadosSoc.cpf !== null && String(dadosSoc.cpf).trim() !== '' && validarCpf(dadosSoc.cpf)) {
            this.formComplementares.CPF = aplicarMascaraCpf(dadosSoc.cpf);
            this.cpfValido = true;
          }

          if (dadosSoc.birthDate !== undefined && dadosSoc.birthDate !== null && String(dadosSoc.birthDate).trim() !== '') {
            const dataBR = formatDateBR(dadosSoc.birthDate);
            if (isDataValida(dataBR)) {
              this.paciente.dataNascimento = dataBR;
            }
          }

          if (dadosSoc.gender !== undefined && dadosSoc.gender !== null && String(dadosSoc.gender).trim() !== '') {
            const genero = String(dadosSoc.gender).trim();
            if (genero === '1' || genero === 1) {
              this.paciente.sexo = 'M';
            } else {
              this.paciente.sexo = 'F';
            }
          }
        }
      } catch (e) {
        showDialog({
          icon: 'error',
          title: this.$t('dicom_plus.dialog_message.error'),
          text: this.$t('dicom_plus.soc.error_processing_multiple_selection'),
          confirmButtonText: 'OK'
        });
      }
    },
    async onSocPageChange(newPage, newPageSize) {
      this.socPage = newPage;
      this.socPageSize = newPageSize;
      await this.abrirSoc(this.campoSocAtivo);
    },
    async onSelecionarFichaConfirmation(id, especialidadeCodigo, especialidadeNome) {
      await showDialog({
        title: this.$t('dicom_plus.dialog_message.confirmation'),
        text: this.$t('dicom_plus.soc.confirm_select_soc_file'),
        denyButtonText: this.$t('dicom_plus.no'),
        confirmButtonText: this.$t('dicom_plus.soc.select'),
        icon: 'question',
        focusConfirm: false,
        focusDeny: true,
        confirmed: () => this.onSelecionarFicha(id, especialidadeCodigo, especialidadeNome)
      })
    },
     onSelecionarFicha(portalSocId, especialidadeCodigo, especialidadeNome) {
      this.selectedFichaId = portalSocId;
      this.mostrarSoc = false;
      if (especialidadeCodigo && especialidadeNome) {
        this.especialidadeSearch = especialidadeNome;
        this.estudo.especialidade = especialidadeCodigo;
      }
    },
    async removerFichaConfirmacao(){
      await showDialog({
          title: this.$t('dicom_plus.dialog_message.confirmation'),
          text: this.$t('dicom_plus.soc.confirm_remove_soc_file'),
          denyButtonText: this.$t('dicom_plus.no'),
          confirmButtonText: this.$t('dicom_plus.soc.remove'),
          icon: 'question',
          focusConfirm: false,
          focusDeny: true,
          confirmed: this.removerFicha
        })
    },
    removerFicha(){
      this.selectedFichaId = null;
    },
    isFieldEditable(campo) {
      if (this.isExamEditable) return true
      if (!campo) return false
      const special = Number(campo.special)
      if (special === 1 && this.isExamLaudado) {
        return true
      }
      return false
    },
    onRequisicaoInput(e) {
      const raw = e.target.value || '';
      const onlyDigits = String(raw).replace(/\D/g, '');
      if (e.target.value !== onlyDigits) e.target.value = onlyDigits;
      this.procedimentoID = onlyDigits;
    },
    limparListaDuplicacao() {
      this.duplicacoes = [
        { specialityID: '', subSpeciality: '', requisicaoID: '', procedimento: '', deleted: false }
      ];
      this.especialidadePrincipalLabel()
    },
    async verificarExameDuplicado(){
      const dicomPlusID = this.exam.dicomPlusID;
      const res = await this.getDicomPlusHistory(dicomPlusID)
      this.isExameDuplicate = res[0]?.isDuplicate || false;

      return this.isExameDuplicate;
    },
    onComentarioInput() {
      if (!this.estudo.comentarios) {
        this.isCommentOverflow = false
        this.currentCharCount = 0
        this.exceededChars = 0
        return
      }

      const sanitized = this.estudo.comentarios.replace(/<\/?[^>]+(>|$)/g, '')

      const byteLength = new TextEncoder().encode(sanitized).length

      this.currentCharCount = byteLength

      this.isCommentOverflow = byteLength > this.MAX_COMMENT_BYTES

      this.exceededChars = this.isCommentOverflow
        ? byteLength - this.MAX_COMMENT_BYTES
        : 0

      this.estudo.comentarios = sanitized
    },

    onComentarioBlur() {
      if (this.estudo.comentarios) {
        this.estudo.comentarios = this.estudo.comentarios.trim()

        const byteLength = new TextEncoder().encode(this.estudo.comentarios).length
        this.currentCharCount = byteLength
        this.isCommentOverflow = byteLength > this.MAX_COMMENT_BYTES
        this.exceededChars = this.isCommentOverflow
          ? byteLength - this.MAX_COMMENT_BYTES
          : 0
      }
    },
    async buscarMostrarMedico() {
      const sourceID = this.exam.fonteID;
      const modalityID = this.exam.categoria;
      if (!sourceID || !modalityID) return;

      const res = await this.getShowPhysician(sourceID, modalityID)
      this.setPhysician = res.setPhysician;
      this.physicianRequired = res.physicianRequired;
    }
  },
  async mounted() {
    this.carregarEspecialidades()
    this.buscarTiposDeContrasteEViaAdministracao()
    this.buscarTiposDeAvaliacaoOncologiaEDiagnostico()
    this.buscarPrioridades()
    this.buscarAnexoTipo()
    this.verificarExameDuplicado()
    document.addEventListener('click', this.fecharDropdownEspecialidade)
    await this.buscarCamposComplementares()
    await this.buscarPaciente()
    await this.storeInitialState()
    await this.buscarMostrarMedico()
    document.addEventListener('downloadLink', this.downloadLink)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.fecharDropdownEspecialidade)
  },
  computed: {
    isExamEditable() {
      return this.exam?.status === CONSTANTS.DICOM_PLUS_STATUS.PENDENTE;
    },
    isPatientEditable() {
    return (
      this.exam?.status === CONSTANTS.DICOM_PLUS_STATUS.PENDENTE ||
      this.exam?.status === CONSTANTS.DICOM_PLUS_STATUS.EXAME_CRIADO
    );
  },
    isMamografiaEditable() {
      const categoria = this.exam?.categoria
      return categoria === 'DX' || categoria === 'CR' || categoria === 'MG'
    },
    especialidadePrincipalLabel() {
      const value = this.estudo.especialidade;
      const opts = this.estudo.especialidadeDuplicarOptions || [];
      const found = opts.find(e => String(e.value) === String(value));
      return found ? found.label : '';
    },
    isContrasteMarcado() {
      return this.estudo.contraste === 1 || this.estudo.contraste === "1" || this.estudo.contraste === true;
    },
    isOncologiaMarcado() {
      return this.estudo.oncologico === 1 || this.estudo.oncologico === "1" || this.estudo.oncologico === true;
    },
    isEmergencia() {
      const result = this.estudo.prioridade === CONSTANTS.DICOM_PLUS_PRIORIDADE.EMERGENCIA;
      return result;
    },
    hasDuplicacao() {
      return Array.isArray(this.duplicacoes) && this.duplicacoes.some(
      d => d && d.specialityID && String(d.specialityID).trim() !== '' && !d.deleted
      );
    },
    isBuscarDisabled() {
      const id = String(this.procedimentoID || '').trim();
      const disabled = (this.isExamNotExistGestorSaude === true) ||
                       (!this.isExamEditable && !this.isExamLaudado) ||
                       id === '';
      return disabled;
    },
    isExamLaudado(){
      return (
        this.exam?.examStatus === CONSTANTS.STATUS.LAUDO_LIBERADO ||
        this.exam?.examStatus === CONSTANTS.STATUS.LAUDADO
      )
    },
    visibleDuplicacoes() {
      return (this.duplicacoes || []).filter(d => !d.deleted);
    },
    duplicacaoGridTemplateColumns() {
      if (this.exam.enviaParaGSaudeApp && !this.isExamNotExistGestorSaude) {
        return '160px 1fr 1fr 1fr 105px';
      }
      return '1fr 1fr 105px';
    },
    duplicacaoComboWidth() {
      if (this.exam.enviaParaGSaudeApp && !this.isExamNotExistGestorSaude) {
        return '70vw';
      }
      return '50vw';
    },
    isGestorSaudeDisabled(){
      if(this.exam.enviaParaGSaudeApp){
        return !this.isExamNotExistGestorSaude;
      }
      return false;
    },
    cpfCampo() {
      return (this.camposComplementares || []).find(c => Number(c.special) === CONSTANTS.DICOM_PLUS_FONTE_CABECALHO_TAG.CPF) || null;
    },
     MAX_COMMENT_CHARS() {
      return this.MAX_COMMENT_BYTES
    },
    showPhysicianField() {
      return this.setPhysician;
    },
    isPhysicianRequired() {
      return this.physicianRequired;
    },
    isPhysicianFieldRequired () {
      return this.isPhysicianRequired && this.showPhysicianField
    }
  }
}
